import { useEffect, useRef, useState } from 'react'
import './index.scss'
import util from '../../utils/util';
import DrawerDialog, { DrawerDialogRef } from '../Base/DrawerDialog';
import Block from '../Base/Block';
import View from '../Base/View';
import ScrollView from '../Base/ScrollView';
import CouponItem from '../CouponItem';
import userUtils from '../../manager/userUtils';
import httpUtil from '../../utils/httpUtil';
import { toast } from '../../utils/toast';

const CouponListPannel = (prop: {
    couponList: any[],
    onListreloadrequest: () => void,
    children: React.ReactNode
}) => {

    const [couponList, setCouponList] = useState<any>([]);
    const [needRequestListReloadWhenClosed, setNeedRequestListReloadWhenClosed] = useState<boolean>(false);
    const drawerRef = useRef<DrawerDialogRef>()

    useEffect(() => {
        const newValue = prop.couponList;
        if (typeof newValue !== typeof undefined && newValue.length > 0) {
            newValue.forEach(function (item, index, attr) {
                item.StartDateStr = item.StartDate
                item.EndDateStr = item.EndDate
                item.StartDate = util.getTimeArry(item.StartDate)
                item.EndDate = util.getTimeArry(item.EndDate)
            })
            setCouponList(newValue)
        }
    }, [prop.couponList])

    const _onPannelStateChange = (visible: boolean) => {
        if (!visible && needRequestListReloadWhenClosed) {
            if (prop.onListreloadrequest) {
                prop.onListreloadrequest()
            }
            setNeedRequestListReloadWhenClosed(false)
        }
    }

    const _onItemClick = (couponInfo: any) => {
        if (!util.allowClick()) {
            return
        }
        var that = this
        var coupon = couponInfo
        var needLogin = !userUtils.isLogin();
        userUtils.doTaskInLoginState(function (state) {
            if (state.success) {
                httpUtil.link(
                    {
                        apiName: 'discountreceive',
                        id: coupon.Id,
                    },
                    'POST',
                    {},
                    true,
                    function (success: boolean, resdata: any, tips: string) {
                        toast.info(success ? '领取成功' : tips)
                        // 领成功之后，已领数字加1，盖章已领取
                        if (success) {
                            // 盖章
                            var resultList = couponList
                            var targetIndex = resultList.findIndex((item: any) => {
                                return item.Id == coupon.Id
                            })
                            if (targetIndex !== -1) {
                                resultList[targetIndex].CustomerReceivedCount += 1
                            }
                            // 通知外部需要重新在弹窗关闭时刷新列表数据
                            setNeedRequestListReloadWhenClosed(true);
                            setCouponList(resultList);
                        }
                        if (needLogin) {
                            if (prop.onListreloadrequest) {
                                prop.onListreloadrequest()
                            }
                        }
                    }
                )
            } else {
                toast.info('登录后领券~')
            }
        })
    }

    return <>
        <Block>
            <View onClick={()=>{
                  drawerRef.current?.open()
            }}>
                {prop.children}
            </View>
        </Block>
        <DrawerDialog
            ref={drawerRef}
            direction={0}
            onVisibleChange={_onPannelStateChange}
        >
            <Block>
                <View
                    className="pannel-content"
                >
                    <View className="pannel-title">可领优惠券</View>
                    <ScrollView
                        className="coupon-list"
                        scrollY={true}
                        enableBackToTop={true}
                        scrollWithAnimation={true}
                    >
                        <Block>
                            {couponList?.map((item: any, index: number) => {
                                return (
                                    <Block     key={`${item.Id}-${index}`}>
                                        <CouponItem
                                            couponInfo={item}
                                            state={3}
                                            select={false}
                                            onClick={_onItemClick}
                                        ></CouponItem>
                                    </Block>
                                )
                            })}
                        </Block>
                    </ScrollView>
                    <View className="confirm-btn" onClick={() => {
                        drawerRef.current?.close()
                    }}>
                        收起
                    </View>
                </View>
            </Block>
        </DrawerDialog>
    </>
}


export default CouponListPannel